import { useContext } from "react";
import { SelectUploadImageContext } from "./context";
import { SelectUploadImageContextType } from "./types";

export const useSelectUploadImageProvider = () => {
  const c = useContext<SelectUploadImageContextType | undefined>(
    SelectUploadImageContext
  );
  if (!c)
    throw new Error(
      "useSelectUploadImageProvider must be used within SelectUploadImageProvider"
    );
  return c;
};
